import { KEY } from './constants'

export const SET = `${KEY}/SET`
export const CLEAR = `${KEY}/CLEAR`
export const SET_UPLOADING = `${KEY}/SET_UPLOADING`
export const ADD_FILE = `${KEY}/ADD_FILE`
export const ARCHIVE_FILE = `${KEY}/ARCHIVE_FILE`
export const RESTORE_FILE = `${KEY}/RESTORE_FILE`
export const MOVE_FILE = `${KEY}/MOVE_FILE`
export const RENAME_FILE = `${KEY}/RENAME_FILE`
export const SELECT_PATH = `${KEY}/SELECT_PATH`
